const initialState = {
   data: [],
   totalCounts: 0,
   cacheInformation: {},
   sportTabs: []
};

const businessReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ATHLETES_PROFILE':
      return { ...state, data: action.payload, totalCounts: action.totalCounts };

    case 'CLEAR_ATHLETES':
      return { ...state, data: [], totalCounts: 0 };
    
    case 'GET_SPORT_TABS':
      return { ...state, sportTabs: action.payload };
    
    case 'GET_CACHE_INFORMATION':
      return { ...state, cacheInformation: action.payload };
    
    case 'CLEAR_BUSINESS_ATHLETE':
      return { ...state, athlete: null };
    
    case 'CLEAR_BUSINESS_CACHE_INFORMATION':
      return { ...state, cacheInformation: null };

    default:
      return state;
  }
};

export default businessReducer;
